<template>
  <div id="quizcontainter">
    <div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
      <div class="progress" v-if="tick">
        <div class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :aria-valuenow="1 - tick.Percentage"
              aria-valuemin="0"
              aria-valuemax="100"
              v-bind:style="{ width: tickPercentage }">
              {{ tick.Remaining }} seconden
        </div>
      </div>
    </div>
    <div class="container">
      <ConnectionErrors />
      <div class="card-deck mb-3">
        <!-- New Quiz -->
        <div class="card mb-4 box-shadow text-center" v-if="currentQuestion">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">{{ currentQuestion.SequenceNumber}}: {{ currentQuestion.QuestionText }}</h4>
          </div>
          <div class="card-body" v-for="(item, index) in currentQuestion.Answers" :key="index">
                <button type="button" :class="getLetter(item.Value)"
                        class="btn btn-lg big"
                        :disabled="showWaitScreen && answer != 'getLetter(item.Value)' ? true : false"
                        @click.prevent="answerQuestion(getLetter(item.Value))">{{ getLetter(item.Value) }}
                        </button>
          </div>
        </div>
      </div>
      <button type="button"
            class="btn btn-danger"
            v-if="isConnected && joinedGame"
            @click.prevent="leaveGame()">Spel verlaten
            </button>
    </div>
    <div class="waitScreen text-center cover-container d-flex w-100 h-100 p-3 mx-auto flex-column" v-if="showWaitScreen || !currentQuestion">
      <main role="main" class="inner cover">
        <h1 class="cover-heading">Een ogenblik geduld</h1>
        <span>De volgende vraag kan elk moment komen</span>
        <div class="list-group-item d-flex justify-content-between align-items-center" style="border: 0;" v-if="userPoints">
            Behaalde punten
            <span class="badge badge-primary badge-pill">{{ userPoints.Points }}</span>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConnectionErrors from '@/components/ConnectionErrors.vue'

export default {
  name: 'quiz',
  computed: {
    ...mapGetters({
      isConnected: 'quiz/connected',
      gameState: 'quiz/gameState',
      currentQuestion: 'quiz/currentQuestion',
      joinedGame: 'quiz/joinedGame',
      showWaitScreen: 'quiz/showWaitScreen',
      tick: 'quiz/tick',
      gameStarted: 'quiz/gameStarted',
      tickPercentage: 'quiz/tickPercentage',
      answer: 'quiz/answer',
      userPoints: 'quiz/userPoints'
    })
  },
  components: {
    ConnectionErrors
  },
  methods: {
    answerQuestion (value) {
      if (!this.showWaitScreen) {
        this.$store.dispatch('quiz/answerQuestion', value)
      }
    },
    leaveGame: function () {
      if (confirm('Weet je zeker dat je het spel wilt verlaten?')) {
        this.$store.dispatch('quiz/leaveGame')
      }
    },
    getLetter (value) {
      if (value === 1) return 'A'
      if (value === 2) return 'B'
      if (value === 3) return 'C'
      if (value === 4) return 'D'
      return 'E'
    },
    getColor (value) {
      if (value === 1) return '#007bff'
      if (value === 2) return '#28a745'
      if (value === 3) return '#dc3545'
      if (value === 4) return '#ffc107'
      return 'E'
    }
  },
  created () {
    this.$store.showWaitScreen()
  }
}
</script>

<style scoped>
button.big {
  height: 120px;
  width: 50%;
  color: #fff;
}
</style>
<style>
button.big.A {
    background-color: #007bff;
}
button.big.B {
    background-color: #28a745;
}
button.big.C {
    background-color: #dc3545;
}
button.big.D {
    background-color: #ffc107;
}
.waitScreen {
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
